var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FanZoneHeader',{attrs:{"loginForename":_vm.loginForename}}),_c('b-container',[_c('div',{staticClass:"spaceTop"},[_c('h1',{staticClass:"Title"},[_vm._v("Exclusive from the Sunshine Tour")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }